import React from "react";
import { Controller } from "react-hook-form";
import {
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  Alert,
} from "@mui/material";
import { FormattedMessage } from "react-intl";
import { REPORT_CATEGORIES } from "../constants/reportCategories";

export const SubcategoryStep = ({ control, errors, selectedCategory }) => {
  const currentCategory = REPORT_CATEGORIES.find(cat => cat.id === selectedCategory);
  
  if (!currentCategory?.subcategories?.length) {
    return null;
  }

  return (
    <FormControl component="fieldset" fullWidth>
      <Controller
        name="subcategory"
        control={control}
        rules={{ required: "general.please-choose-subcategory" }}
        render={({ field }) => (
          <RadioGroup
            {...field}
            aria-label="report-subcategory"
          >
            {currentCategory.subcategories.map((subcategory) => (
              <FormControlLabel
                key={subcategory.id}
                value={subcategory.id}
                control={<Radio />}
                label={
                  <FormattedMessage
                    id={`abuse-report.category.${subcategory.id}`}
                    defaultMessage={subcategory.name}
                  />
                }
              />
            ))}
          </RadioGroup>
        )}
      />
      {errors.subcategory && (
        <Alert severity="error" sx={{ mt: 1 }}>
          <FormattedMessage id={errors.subcategory.message} defaultMessage={errors.subcategory.message} />
        </Alert>
      )}
    </FormControl>
  );
};
